export const TOTAL_PREDICTION = 'total';
export const OWN_PREDICTION = 'own';
export const GROUPS_TOTAL_PREDICTION = 'groupsTotal';
export const MY_FORECAST = 'My forecast';

export const MIN_SCROLL_DISTANCE = 0;
export const MAX_SCROLL_DISTANCE = 1;
export const SCROLL_STEP = (MAX_SCROLL_DISTANCE - MIN_SCROLL_DISTANCE) / 100;
